<template>
  <div>
    <datepicker @closed="passDateToParent"
                v-model="date"
                :clear-button="true"
                :required="true"
                :disabled-dates = "this.disabledDates"
    ></datepicker>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import EventBus from "@/components/EventBus";
import moment from 'moment';
export default {
  name: "DatePicker",
  components: {
    Datepicker
  },
  data() {
    return{
      date: new Date(),
      disabledDates: {
        from: new Date(), // Disable all dates after today
        days: [6, 0], // Disable Saturday's and Sunday's
      }
    }
  },

  methods: {
    passDateToParent(){
      this.date = moment(this.date).format('YYYY-MM-DD H:MM')
      EventBus.$emit('date-set', this.date)
    }
  }
}
</script>